const KEYS = [ 'display', 'question', 'highchart' ];

export const parseAnswer = (data) => {
    const arr = data.split('\n\n');

    let text = '找不到相關訊息';
    
    if (!data.includes(text)) {
        text = {
            conclusion: [],
            display: [],
            highchart: {},
            question: [],
        };
        
        for (let i = 0; i < arr.length; i++) {
            let temp = arr[i];

            for (let j = 0; j < KEYS.length; j++) {
                const key = KEYS[j];

                if (typeof temp === 'object' || !temp.includes(`type:${key}`)) { continue; }

                temp = temp.replaceAll('```', '');
  
                let idxStart = temp.indexOf('[');
                let idxEnd = temp.indexOf(']');
  
                if (key === 'highchart' && temp.includes('highchart')) {
                    idxStart = temp.indexOf('highchart') + 9;
                    idxEnd = temp.length - 1;

                    let cleanHighchartText = temp.substr(idxStart, idxEnd);
    
                    if (cleanHighchartText.includes('highchart')){
                        idxStart = idxStart +cleanHighchartText.indexOf('highchart') + 9;
                    }
                }

                temp = temp.substr(idxStart, idxEnd).replace('json', '');
                temp = JSON.parse(temp);
                text[key] = temp;
            }
        }
        
        text.conclusion = arr.filter((item) => {
          let isConclusion = true;
  
          for (let i = 0; i < KEYS.length; i++) {
            isConclusion = !item.includes(KEYS[i]);
  
            if (!isConclusion) { return isConclusion; }
          }
  
          return isConclusion;
        });
    }

    return text;
};